import styled from "@emotion/styled";
import React from "react";
import { CustomThemeType } from "../../context/Providers";

const ButtonWrapper = styled.button<{ theme?: CustomThemeType; size: string }>`
  background-color: color-mix(in hsl, ${(p) => p.theme.ctaColor}, white 0%);
  color: ${(p) => p.theme.ctaContrast};
  padding: ${(p) =>
    p.size === "lg"
      ? "2rem 3rem"
      : p.size === "md"
        ? "2rem 3rem"
        : p.size === "sm"
          ? "1rem 2rem"
          : "0.85rem 1.5rem"};
  border-radius: 0.5rem;
  font-family: "Inter";
  font-size: ${(p) =>
    p.size === "lg"
      ? "2rem"
      : p.size === "md"
        ? "1.5rem"
        : p.size === "sm"
          ? "1.2rem"
          : "1rem"};
  display: flex;
  justify-content: center;
  align-items: center;
  &:disabled {
    background-color: color-mix(
      in srgb,
      ${(p) => p.theme.foreground},
      ${(p) => p.theme.background} 50%
    );
  }
  &:disabled:hover {
    background-color: color-mix(
      in srgb,
      ${(p) => p.theme.foreground},
      ${(p) => p.theme.background} 50%
    );
  }
  &:hover {
    background-color: color-mix(in hsl, ${(p) => p.theme.ctaColor}, black 20%);
  }
`;

interface CustomProps {
  children: any;
  size: "xs" | "sm" | "md" | "lg";
  onClick?: (e: any) => any;
}
type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & CustomProps;

const Button: React.FC<ButtonProps> = ({
  children,
  size = "sm",
  onClick,
  ...rest
}) => {
  return (
    <ButtonWrapper
      type="button"
      size={size}
      onClick={(e) => onClick?.(e)}
      {...rest}
    >
      {children}
    </ButtonWrapper>
  );
};

export default Button;
